module.exports = __webpack_public_path__ + "static/media/metro4.68e1ecba.jpg";